import { fontList } from '../../core/font-list';
import {colorListPairs, colorMap,colorListCharts} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 20,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 100,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 50,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColor': {
      'default': '#B9D420',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconColor': {
      'default': '#658C1D',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 0.4,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': 40,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': 40,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundX': {
      'default': 510,
      'label': 'logoBackgroundX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundY': {
      'default': 85,
      'label': 'logoBackgroundY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundRadius': {
      'default': 60,
      'label': 'logoBackgroundRadius',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundColor': {
      'default': '#FFFFFF',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBorderColor': {
      'default': '#658C1D',
      'label': 'logoBorderColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBackgroundRadiusWidth': {
      'default': 3,
      'label': 'logoBackgroundRadiusWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusLogoWidth': {
      'default': 55,
      'label': 'tilastokeskusLogoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusLogoX': {
      'default': 510,
      'label': 'tilastokeskusLogoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusLogoY': {
      'default': 85,
      'label': 'tilastokeskusLogoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusLogoColor': {
      'default': '#222222',
      'label': 'tilastokeskusLogoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'tilastokeskusTextWidth': {
      'default': 380,
      'label': 'tilastokeskusTextWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusTextX': {
      'default': 60,
      'label': 'tilastokeskusTextX',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusTextY': {
      'default': 220,
      'label': 'tilastokeskusTextY',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1X': {
      'default': 40,
      'label': 'titleTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1Y': {
      'default': 320,
      'label': 'titleTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1': {
      'default': 'Tuontipolttoaineiden\nhinnat',
      'label': 'titleTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleTextSlide1FontSize': {
      'default': 48,
      'label': 'titleTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1LineHeight': {
      'default': 1.4,
      'label': 'titleTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1FontColor': {
      'default': '#658C1D',
      'label': 'titleTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1X': {
      'default': 40,
      'label': 'textSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1Y': {
      'default': 450,
      'label': 'textSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1': {
      'default': 'nousivat vuoden 2017\nviimeisellä neljänneksellä',
      'label': 'textSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textSlide1FontSize': {
      'default': 32,
      'label': 'textSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1LineHeight': {
      'default': 1.4,
      'label': 'textSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'textSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1FontWeight': {
      'default': 'bold',
      'label': 'textSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': 'Maakaasu',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 20,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 44,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 32,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': '10 prosenttia korkeampi kuin',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line2': {
      'default': 'vuotta aiemmi',
      'label': 'subtitleTextSlide2Line2',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2X': {
      'default': 20,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 78,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#658C1D',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 0,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 40,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 2,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': '€/MWh',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'Open Sans',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 24,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Open Sans',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '2008',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2017',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#0574B0'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Maakaasu'], [23.25], [23.82], [24.38], [25.1], [25.67], [26.34], [27.27], [28.6], [29.74], [30.45], [30.57], [29.86], [29.43], [27.8], [26.04], [24.42], [23.51], [23.25], [24.1], [24.1], [24.61], [25.15], [25.52], [25.94], [25.83], [26.22], [26.51], [27.24], [28], [28.47], [29.13], [29.58], [29.93], [29.9], [29.75], [29.81], [29.25], [29.64], [30.24], [30.52], [32.77], [33.7], [34.55], [35.3], [35.58], [35.53], [35.35], [35.63], [35.99], [36.34], [37.04], [37.86], [38.4], [38.6], [38.35], [38.06], [37.97], [37.56], [37.1], [36.66], [36.766], [36.564], [36.151], [35.678], [35.335], [35.236], [35.208], [35.022], [34.66], [34.464], [34.293], [34.097], [34.05], [33.814], [33.823], [33.837], [33.84], [33.86], [33.934], [33.957], [33.637], [33.322], [32.868], [32.013], [30.684], [28.962], [27.824], [26.597], [25.843], [25.55], [25.671], [25.981], [25.45], [24.911], [24.164], [23.206], [21.955], [20.802], [20.11], [19.555], [22.325], [22.219], [22.461], [23.009], [23.549], [24.077], [24.888], [25.663], [25.904], [26.652], [27.243], [27.553], [27.559], [27.428], [27.055], [26.838], [26.847], [27.255], [27.675], [28.251]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColor', 'iconColor', 'iconOpacity', 'iconX', 'iconY', 'titleTextSlide1', 'titleTextSlide1Y', 'textSlide1', 'textSlide1Y'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-tilastokeskus-triptych-line-hor-steps/social.params.ts